import { CloseCircleOutlined, DoubleRightOutlined, EllipsisOutlined } from '@ant-design/icons';
import {
  App, Dropdown, Flex, Tag, Tooltip, Typography,
} from 'antd';
import { WL_CONFIG } from 'constants';
import React from 'react';
import { formatPhoneNumber } from 'utils';
import { getStatusTagColor } from '../../utils';

function Contact({
  contact, onEdit, onMakePrimary, onRemove, onCancelWorkflow,
}) {
  const runningWorkflows = contact.workflow_runs?.filter((workflowRun) => workflowRun?.running !== false) || [];

  return (
    <Flex vertical>
      <Flex justify="space-between">
        <Typography.Text className="font-bold ">
          {contact.first_name}
          {' '}
          {contact.last_name}
          {contact.is_primary && <Tag className="ml-3">Primary</Tag>}
        </Typography.Text>
        <div className="whitespace-nowrap">
          {
            ['Lapsed', 'Churned', 'Potential', 'Customer'].includes(contact.status) && (
              <Tag color={getStatusTagColor(contact.status)}>
                {contact.status}
              </Tag>
            )
          }
          <Dropdown
            placement="bottomRight"
            menu={{
              items: [
                !contact.is_primary && {
                  key: '0',
                  label: <a type="text" onClick={() => onMakePrimary(contact.id)}>Make it primary</a>,
                },
                {
                  key: '1',
                  label: <a type="text" onClick={() => onEdit(contact)}>Edit</a>,
                },
                {
                  key: '2',
                  label: <a type="text" onClick={() => onRemove(contact)}>Remove</a>,
                },
              ],
            }}
          >
            <EllipsisOutlined />
          </Dropdown>
        </div>

      </Flex>
      <Typography.Text>{contact.role}</Typography.Text>
      <Flex justify="space-between" align="center">
        <Typography.Text>{contact.email}</Typography.Text>
        {
          contact.is_unsubscribed && (
            <Typography.Text type="danger" className="text-xs whitespace-nowrap">Unsubscribed</Typography.Text>
          )
        }
      </Flex>

      <Typography.Text>{formatPhoneNumber(contact.phone)}</Typography.Text>
      {
        runningWorkflows.length > 0 && (
          <Flex
            vertical
            gap={4}
            className="my-2 py-1 px-2 rounded-md"
            style={{
              backgroundColor: '#F2F7F4',
            }}
          >
            {runningWorkflows.map((workflowRun) => (
              <Flex
                align="center"
                gap={8}
                key={workflowRun.workflow.id}
                justify="space-between"
              >
                <Flex
                  align="center"
                  gap={8}
                  key={workflowRun.workflow.id}
                >
                  <DoubleRightOutlined
                    style={{
                      color: WL_CONFIG.colors.primary,
                      border: `1px solid ${WL_CONFIG.colors.primary}`,
                      borderRadius: 2,
                      fontSize: 10.5,
                      padding: 1,
                    }}
                  />
                  <Typography.Text>{workflowRun.workflow.name}</Typography.Text>
                </Flex>
                <CloseCircleOutlined
                  style={{
                    fontSize: 12,
                    cursor: 'pointer',
                    color: '#999',
                  }}
                  onClick={() => onCancelWorkflow(workflowRun)}
                />
              </Flex>
            ))}
          </Flex>
        )
      }
    </Flex>
  );
}

export default Contact;
